exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cardLogin__login-module___WXxlb {\n    padding: 50px;\n    border: none;\n    /* background-color:#FAFBFE; */\n}\n\n.container__login-module___3QsMC {\n    /* background-color:#FAFBFE; */\n}\n\n.forgotLink__login-module___35FmD {\n    margin: 16px 0;\n    cursor: pointer;\n}\n\n.formControl__login-module___1mTm9 {\n    margin-top: 16px;\n}", ""]);

// Exports
exports.locals = {
	"cardLogin": "cardLogin__login-module___WXxlb",
	"container": "container__login-module___3QsMC",
	"forgotLink": "forgotLink__login-module___35FmD",
	"formControl": "formControl__login-module___1mTm9"
};